<template>
  <b-card>
    <b-tabs ref="businessDetailManagementTabBar">
      <b-tab>
        <template #title>
          <span
            v-can="'view-merchant-business'"
          >General Details</span>
        </template>
        <MerchantBusinessGeneralDetailsManagement
          :approval-group-status="approvalGroupStatus.toString()"
          :approval-type="types.generalDetails"
        />
      </b-tab>
      <b-tab>
        <template #title>
          <span
            v-can="'view-merchant-address'"
          >Addresses & Contact Details</span>
        </template>
        <MerchantBusinessAddressManagement
          :approval-group-status="approvalGroupStatus.toString()"
          :approval-type="types.addressContactDetails"
        />
      </b-tab>
      <b-tab>
        <template #title>
          <span
            v-can="'view-merchant-bank'"
          >Bank Details</span>&nbsp;
        </template>
        <MerchantBusinessBankDetailsManagement
          :approval-group-status="approvalGroupStatus.toString()"
          :approval-type="types.bankDetails"
        />
      </b-tab>
      <b-tab>
        <template #title>
          <span
            v-can="'view-merchant-bank'"
          >Users</span>
        </template>
        <MerchantBusinessUserManagement
          :approval-group-status="approvalGroupStatus.toString()"
          :approval-type="types.users"
        />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
} from 'bootstrap-vue'
import MerchantBusinessAddressManagement from '@/views/merchant/MerchantBusinessAddressManagement.vue'
import MerchantBusinessBankDetailsManagement from '@/views/merchant/MerchantBusinessBankDetailsManagement.vue'
import MerchantBusinessUserManagement from '@/views/merchant/MerchantUserManagement.vue'
import MerchantBusinessGeneralDetailsManagement from '@/views/merchant/MerchantBusinessGeneralDetailsManagement.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const MerchantRepository = RepositoryFactory.get('merchant')

export default {
  components: {
    MerchantBusinessAddressManagement,
    MerchantBusinessBankDetailsManagement,
    MerchantBusinessUserManagement,
    MerchantBusinessGeneralDetailsManagement,
    BTabs,
    BTab,
    BCard,
  },
  data() {
    return {
      approvalGroupStatus: '',
      types: {
        generalDetails: {},
        addressContactDetails: {},
        bankDetails: {},
        users: {},
      },
    }
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.__preserveTabOnRefresh('businessDetailManagementTabBar', 'businessDetailManagementTabIndex')
    this.getApprovalGroupStatus()
    this.getApprovalTypeStatus()
  },
  methods: {
    async getApprovalGroupStatus() {
      try {
        const approvalGroup = 2
        const { data } = (await MerchantRepository.getApprovalGroupStatus(approvalGroup)).data
        this.approvalGroupStatus = data.status
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getApprovalTypeStatus() {
      try {
        const approvalGroup = 2
        const response = await MerchantRepository.getApprovalTypeStatus(approvalGroup)
        const { data } = response.data

        const types = {
          generalDetails: this.getStatus(data, 'Merchant General business settings'),
          addressContactDetails: this.getStatus(data, 'Merchant address and contact details'),
          bankDetails: this.getStatus(data, 'Merchant Bank details'),
          users: this.getStatus(data, 'Merchant users'),
        }
        this.types = types
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    getStatus(data, type) {
      const item = data.find(entry => entry.type === type)
      return item
    },
  },
}
</script>

<style>
</style>
